import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" }, null, -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "emailAddress" }, "Email Address", -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "nationalId" }, "National ID", -1)
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "address" }, "Address", -1)
const _hoisted_13 = { class: "p-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "accountType" }, "Account Type", -1)
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '50vw' },
    maximizable: true,
    position: "top",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, _createSlots({
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          for: "accountTitle",
          class: _normalizeClass({ 'p-error': _ctx.v$.accountTitle.$invalid && _ctx.submitted })
        }, "Account Title", 2),
        _createVNode(_component_InputText, {
          id: "accountTitle",
          modelValue: _ctx.v$.accountTitle.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.accountTitle.$model) = $event)),
          modelModifiers: { trim: true },
          class: _normalizeClass({ 'p-invalid': _ctx.v$.accountTitle.$invalid && _ctx.submitted }),
          autoFocus: ""
        }, null, 8, ["modelValue", "class"]),
        (
          (_ctx.v$.accountTitle.$invalid && _ctx.submitted) ||
          _ctx.v$.accountTitle.$pending.$response
        )
          ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.v$.accountTitle.required.$message.replace("Value", "Account Title")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", {
          for: "contactNo",
          class: _normalizeClass({ 'p-error': _ctx.v$.contactNo.$invalid && _ctx.submitted })
        }, "Contact No", 2),
        _createVNode(_component_InputText, {
          id: "contactNo",
          modelValue: _ctx.v$.contactNo.$model,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.contactNo.$model) = $event)),
          modelModifiers: { trim: true },
          class: _normalizeClass({ 'p-invalid': _ctx.v$.contactNo.$invalid && _ctx.submitted })
        }, null, 8, ["modelValue", "class"]),
        (
          (_ctx.v$.contactNo.$invalid && _ctx.submitted) ||
          _ctx.v$.contactNo.$pending.$response
        )
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.v$.contactNo.required.$message.replace("Value", "Contact No")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputText, {
          id: "emailAddress",
          modelValue: _ctx.item.emailAddress,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.emailAddress) = $event)),
          modelModifiers: { trim: true },
          "aria-describedby": "email-error"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_InputText, {
          id: "nationalId",
          modelValue: _ctx.item.nationalId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.nationalId) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputText, {
          id: "address",
          modelValue: _ctx.item.address,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.address) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_Dropdown, {
          id: "accountType",
          modelValue: _ctx.item.accountType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.accountType) = $event)),
          options: _ctx.profilerTypes,
          optionLabel: "key"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_InputText, {
          id: "description",
          modelValue: _ctx.item.description,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.description) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 2
  }, [
    (!_ctx.previewOnly)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              type: "submit",
              label: "Save",
              icon: "pi pi-check",
              class: "p-button-primary",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.saveItem(!_ctx.v$.$invalid)), ["prevent"]))
            })
          ])
        }
      : undefined
  ]), 1032, ["visible", "onHide"]))
}